export default {
    parts: [
        'breadcrumbContainer',
        'contentContainer',
        'pageTitleRow',
        'pageTitle',
        'actionsHeader',
        'actionsLeft',
        'actionButton',
        'actionButtonActive',
        'pageGrid',
        'shareButton',
        'shareIcon',
        'errorBanner',
        'errorBannerText',
        'productGrid',
        'productGridLoadMore',
        'oosProductTile',
        'loadMoreContainer',
        'loadMoreButton',
        'shareModalContent',
        'shareModalBody',
        'shareModalText',
        'shareModalButton',
        'headingRow',
        'pageTitleShareButton',
        'shareButtonDesktop',
        'emptyFolderBox',
        'shareSwitch',
        'gridInterrupter'
    ],
    baseStyle: {
        breadcrumbContainer: {
            maxW: {base: 'full', lg: 'container.xxxl'},
            mx: 'auto',
            mb: '26px',
            px: {base: '16px', lg: '24px'},
            pt: {base: 4, lg: 6}
        },
        contentContainer: {
            w: '100%',
            maxW: {base: 'full', lg: 'container.xxxl'},
            mx: 'auto',
            padding: {base: '0 8px 24px 8px', lg: '0 24px 97px 24px'}
        },
        pageTitleRow: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: {base: 4, lg: 6}
        },
        pageTitle: {},
        // Mobile share button inside the title row (display only on mobile)
        pageTitleShareButton: {
            display: {base: 'flex', lg: 'none'}
        },
        // Action buttons row: spans full width above sidebar+grid
        actionsHeader: {
            display: 'flex',
            w: '100%',
            justifyContent: {base: 'flex-start', lg: 'space-between'},
            alignItems: 'center',
            mb: {base: 0, lg: 6}
        },
        actionsLeft: {
            display: 'flex',
            alignItems: 'center',
            minW: 0,
            flex: 1,
            flexWrap: {base: 'nowrap', lg: 'wrap'},
            overflowX: {base: 'auto', lg: 'visible'},
            gap: '8px',
            '&::-webkit-scrollbar': {display: 'none'},
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
        },
        actionButton: {
            textStyle: 'labelSmMd',
            fontWeight: 'medium',
            border: '1px solid',
            borderColor: 'webTheme.strokeDefault',
            borderRadius: 0,
            px: '8px',
            py: '4px',
            h: '26px',
            minH: 0,
            flexShrink: 0,
            lineHeight: 4,
            textTransform: 'none',
            _hover: {
                '@media (hover: hover)': {
                    bg: 'webButton.btnPrimaryHover',
                    color: 'webTypo.textOnColor'
                }
            }
        },
        actionButtonActive: {
            textStyle: 'labelSmMd',
            fontWeight: 'medium',
            bg: 'webButton.btnPrimaryDefault',
            color: 'webTypo.textOnColor',
            borderRadius: 0,
            px: '8px',
            py: '4px',
            h: '26px',
            minW: '122px',
            minH: 0,
            flexShrink: 0,
            lineHeight: 4,
            textTransform: 'capitalize',
            _hover: {
                '@media (hover: hover)': {bg: 'webButton.btnPrimaryHover'}
            }
        },
        // Desktop: sidebar (220px) + content; Mobile: single column (nav above content)
        pageGrid: {
            display: 'grid',
            w: '100%',
            gridTemplateColumns: {base: '1fr', lg: '220px 1fr'},
            gap: {base: 0, lg: 10},
            alignItems: 'flex-start',
            minW: 0
        },
        shareButton: {
            alignItems: 'center',
            gap: 1,
            h: 'auto',
            minW: 'auto',
        },
        shareIcon: {
            w: '16px',
            h: '16px'
        },
        errorBanner: {
            bg: 'alternativeWarning.100',
            p: 4,
            w: 'fit-content'
        },
        errorBannerText: {
            color: 'warningText',
            fontSize: 'xs'
        },
        productGrid: {
            gridTemplateColumns: {
                base: 'repeat(2, minmax(0, 1fr))',
                md: 'repeat(3, minmax(0, 1fr))'
            },
            columnGap: 2,
            rowGap: {base: 6, lg: 8}
        },
        productGridLoadMore: {
            gridTemplateColumns: {
                base: 'repeat(2, minmax(0, 1fr))',
                md: 'repeat(3, minmax(0, 1fr))'
            },
            columnGap: 2,
            rowGap: {base: 6, lg: 8},
            mt: {base: 6, lg: 8}
        },
        oosProductTile: {
            opacity: 0.5,
            '& [data-wishlist-remove]': {opacity: 1}
        },
        loadMoreContainer: {
            justifyContent: 'center',
            gap: 4,
            mt: 10
        },
        loadMoreButton: {
            width: '100%',
            maxWidth: {base: '100%', lg: '300px'},
            bg: 'black',
            color: 'white',
            fontSize: 'md',
            textTransform: 'uppercase'
        },
        shareModalContent: {
            mb: {base: 0, lg: 'auto'}
        },
        shareModalBody: {
            p: '23px'
        },
        shareModalText: {
            fontSize: 'sm',
            mt: 6,
            mb: '30px'
        },
        shareModalButton: {
            w: 'full',
            mx: 'auto',
            fontSize: 'md'
        },
        headingRow: {
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        pageTitleShareButton: {
            display: {base: 'flex', lg: 'none'}
        },
        shareButtonDesktop: {
            display: {base: 'none', lg: 'flex'}
        },
        emptyFolderBox: {
            bg: 'webTheme.backgroundPrimaryBrand',
            p: '24px',
            mt: '40px',
            mb: {base: '20px', lg: '24px'},
            w: {base: '100%', lg: '688px'},
            textAlign: 'center'
        },
        shareSwitch: {
            '& .chakra-switch__track': {bg: 'webTheme.iconPrimary'},
            '& .chakra-switch__thumb': {bg: 'webTheme.iconOnColor'}
        },
        gridInterrupter: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // Match the product tile image ratio (mediaAspect: 19/28) so the
            // CMS tile fills the grid cell identically to a product tile image.
            aspectRatio: '19 / 28',
            '& > *': {
                width: '100%',
                height: '100%'
            }
        }
    }
}
